import { Dayjs } from 'dayjs';
import { TimestampTzString } from 'zapatos/db';

if (new Date().getFullYear() === 2028) {
    console.warn('******************************************************');
    console.warn('***** daylightSavingsByYear needs to be updated! *****');
    console.warn('******************************************************');
}

const _2AM_EST = '02:00:00-05:00';
const _2AM_EDT = '02:00:00-04:00';

/** Ref: https://www.timeanddate.com/time/change/usa */
const daylightSavingsByYear: {
    [year: number]: [start: TimestampTzString, end: TimestampTzString];
} = {
    2022: [`2022-03-13T${_2AM_EST}`, `2022-11-06T${_2AM_EDT}`],
    2023: [`2023-03-12T${_2AM_EST}`, `2023-11-05T${_2AM_EDT}`],
    2024: [`2024-03-10T${_2AM_EST}`, `2024-11-03T${_2AM_EDT}`],
    2025: [`2025-03-09T${_2AM_EST}`, `2025-11-02T${_2AM_EDT}`],
    2026: [`2026-03-08T${_2AM_EST}`, `2026-11-01T${_2AM_EDT}`],
    2027: [`2027-03-14T${_2AM_EST}`, `2027-11-07T${_2AM_EDT}`],
    2028: [`2028-03-12T${_2AM_EST}`, `2028-11-05T${_2AM_EDT}`],
};

export const isDaylightSavings = (d: Dayjs): boolean => {
    const [start, end] = daylightSavingsByYear[d.get('year')] ?? [];
    return start && end && d.isAfter(start) && d.isBefore(end);
};
